import './soundingEquipment.less'
import { Card, Input, Table } from 'antd'
import { Controller, useFormContext } from 'react-hook-form'
import DateTimeNow from 'components/RobComponents/DateTimeNow'
import i18n from 'domain/i18n/i18n'
import React from 'react'
import RequiredLabel from 'components/RequiredLabel'
import robPermissions from 'constants/robPermissions'
import usePermission from 'hooks/usePermission'

const t = key => i18n.t(`rob.survey.soundingDraftAndTemperature.${key}`)

const EQUIPMENT_ROWS = [
  { key: 'soundingTape', labelKey: 'soundingEquipment.soundingTape' },
  { key: 'thermometer', labelKey: 'soundingEquipment.thermometer' },
]

const getNestedError = (errors, path) =>
  path.split('.').reduce((acc, key) => acc?.[key], errors)

const SoundingEquipment = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext()
  const can = usePermission()
  const canEdit = can(robPermissions.EDIT_GENERAL)

  const columns = [
    {
      dataIndex: 'labelKey',
      key: 'equipment',
      render: labelKey => t(labelKey),
      title: t('soundingEquipment.equipmentLabel'),
      width: 160,
    },
    {
      key: 'serialNo',
      render: (_, record) => {
        const fieldName = `general.soundingDraftAndTemperature.soundingEquipment.${record.key}.serialNo`
        const error = getNestedError(errors, fieldName)

        return (
          <Controller
            control={control}
            name={fieldName}
            render={({ field }) => (
              <div className="sounding-equipment__input-wrap">
                <Input
                  {...field}
                  disabled={!canEdit}
                  status={error ? 'error' : ''}
                />
                <RequiredLabel required />
                {error && (
                  <div className="sounding-equipment__error-msg">
                    {error.message}
                  </div>
                )}
              </div>
            )}
          />
        )
      },
      title: t('soundingEquipment.serialNo'),
      width: 200,
    },
    {
      key: 'calibrationExpiryDate',
      render: (_, record) => {
        const fieldName = `general.soundingDraftAndTemperature.soundingEquipment.${record.key}.calibrationExpiryDate`
        const error = getNestedError(errors, fieldName)

        return (
          <Controller
            control={control}
            name={fieldName}
            render={({ field }) => (
              <div className="sounding-equipment__input-wrap">
                <DateTimeNow
                  disabled={!canEdit}
                  onChange={field.onChange}
                  showTime={false}
                  value={field.value}
                />
                {error && (
                  <div className="sounding-equipment__error-msg">
                    {error.message}
                  </div>
                )}
              </div>
            )}
          />
        )
      },
      title: t('soundingEquipment.calibrationExpiryDate'),
      width: 220,
    },
  ]

  return (
    <Card
      className="sounding-equipment__card"
      size="small"
      title={t('soundingEquipment.title')}
    >
      <Table
        bordered
        columns={columns}
        dataSource={EQUIPMENT_ROWS}
        pagination={false}
        rowKey="key"
      />
    </Card>
  )
}

export default SoundingEquipment
